import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import AboutUs from './pages/AboutUs/AboutUs';
import Contact from './pages/Contact/Contact';
import Opportunities from './pages/Opportunities/Opportunities';
import { ModalProvider } from './contexts/ModalContext'; // Importa el ModalProvider
import './styles/global.css';

const App = () => {
  return (
    <ModalProvider> {/* Envolvemos el Router con ModalProvider */}
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/opportunities" element={<Opportunities />} />
        </Routes>
      </Router>
    </ModalProvider>
  );
}

export default App;
